


export class BinaryFile {

    binaryFileId: string;
    content: string;
    fileName: string;
    fileSize: number;
    _fileName: string;
    _binaryFileId:string;
    _selected:boolean = false;

}
